// countryApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { AllPackageBalance, CorporateWalletBalance, WalletHistoryQuery, WalletPaginationItem } from 'model/wallect-model';
import { baseQueryWithReauth } from './config/interceptor';
import { ApiResponse } from 'model/response-model';

const walletPath = 'Wallet';


export const walletApi = createApi({
  reducerPath: 'walletApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Wallet'],
  endpoints: (builder) => ({
    corporateWalletBalance: builder.query<ApiResponse<CorporateWalletBalance>, void>({
      query: () => ({
        url: `${walletPath}/corporate/balance`,
      })
    }),
    WalletBalanceHistory: builder.query<ApiResponse<WalletPaginationItem>, WalletHistoryQuery>({
      query: (params) => ({
        url: `${walletPath}/transaction/history`,
        params: params
      })
    }),
    packagesWalletBalance: builder.query<ApiResponse<AllPackageBalance[]>, void>({
      query: () => ({
        url: `${walletPath}/AllWallet/balanceHistory`,
      })
    }),
  })
});


export const {
  useCorporateWalletBalanceQuery,
  useWalletBalanceHistoryQuery,
  usePackagesWalletBalanceQuery
} = walletApi;